import "./terms.css";

function Privacy() {
  return (
    <div className="terms-container">
      <h1>Privacy Policy</h1>
      <p>
        We at Insight Headlines, we value your privacy and are committed to
        protecting your personal information. This Privacy Policy explains how
        we collect, use, disclose, and safeguard your data when you use our Job
        Search, Resume, and News App (the "App"). By using the App, you agree to
        the terms outlined in this Privacy Policy. If you do not agree with our
        practices, please discontinue using the App.
      </p>
      <h2>1. Information We Collect</h2>
      <p>
        <span className="highlight">1.1 Personal Information:</span> We may
        collect personal information that you voluntarily provide when using the
        App, such as your name, email address, and other contact details when
        creating a resume.
      </p>
      <p>
        <span className="highlight">1.2 Resume Data:</span> When you create a
        resume using the App, we collect the information you provide in your
        resume, including your skills, experience, and qualifications.
      </p>
      <p>
        <span className="highlight">1.3 Usage Information:</span> We may collect
        information about your interactions with the App, such as the pages you
        visit, the jobs you search for, and your usage patterns.
      </p>
      <h2>2. How We Use Your Information</h2>
      <p>
        <span className="highlight">2.1 Job Search:</span> In the context of job
        search, we want to emphasize that we do not store any personal data or
        information provided by the user. Our job search functionality is
        designed to help users find employment opportunities. and we do not
        retain any data related to your job search queries.
      </p>
      <p>
        <span className="highlight">2.2 Resume:</span> The App allows you to
        create resumes. It is important to note that we do not store or retain
        any data from the resumes you create using the App.
      </p>
      <p>
        <span className="highlight">2.3 News Data:</span> We use the NewsData.io
        API to provide you with news content. Please review the original source
        links provided for news articles to understand the sources of this
        information.
      </p>
      <h2>3. Data Sharing and Disclosure</h2>
      <p>
        <span className="highlight">3.1 Original Source Links:</span> The App
        may provide links to original sources for job listings and news
        articles. Please review these original sources to understand their
        privacy practices.
      </p>
      <p>
        <span className="highlight">3.2 Third-Party Service Providers:</span> We
        may share your data with third-party service providers who assist us in
        providing the App's features. These providers are contractually
        obligated to protect your data. privacy practices.
      </p>
      <h2>4. Security</h2>
      <p>
        We take reasonable measures to protect your data, but no method of data
        transmission over the internet or electronic storage is completely
        secure. We cannot guarantee the security of your data.
      </p>
      <h2>5. Your Choices</h2>
      <p>
        You can update, edit, or delete your resume data at any time. You can
        also unsubscribe from communications sent by us.
      </p>
      <h2>6. Changes to this Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page. These
        changes are effective immediately after they are posted on this page.
      </p>
      <h2>7. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy or your
        data, please contact us at feedback.insightheadlines@outlook.com.
      </p>
      <h2 className="highlight">7.1 Original Source Links</h2>
      Powered by{" "}
      <a href="https://newsdata.io/" target="_blank">
        NewsData.io API
      </a>
      <p>
        By using the App, you acknowledge that you have read, understood, and
        agree to these Terms and Conditions.
      </p>
    </div>
  );
}

export default Privacy;
